import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { getCreator } from '../../utils/catalog';
import { formatPrice } from '../../utils/currency';
import { formatDate, isLeavingSoon } from '../../utils/exhibition';
import type { CartLine } from '../../types/cart';
import { QuantityStepper } from '../ui/QuantityStepper';
interface CartLineItemProps {
  line: CartLine;
  size?: 'compact' | 'large';
  onNavigate?: () => void;
}
export function CartLineItem({
  line,
  size = 'compact',
  onNavigate
}: CartLineItemProps) {
  const {
    updateQuantity,
    removeItem
  } = useCart();
  const {
    product
  } = line;
  const creator = getCreator(product.creatorId);
  const leaving = creator && isLeavingSoon(creator);
  const large = size === 'large';
  return <div className={`flex gap-4 ${large ? 'md:gap-6' : ''}`} data-id="element-57" data-mp="3oi4xuihu459i">
      <Link to={`/produit/${product.id}`} onClick={onNavigate} className={`shrink-0 overflow-hidden rounded-sm bg-shell ${large ? 'h-32 w-24 md:h-40 md:w-32' : 'h-28 w-20'}`} data-id="element-58" data-mp="3ojpr84sexi5s">
        <img src={product.images[0]} alt={product.name} className="h-full w-full object-cover" data-id="element-59" data-mp="2huwjfo0q2alc" />
      </Link>
      <div className="flex min-w-0 flex-1 flex-col" data-id="element-60" data-mp="236a5nqqqtqw8">
        <div className="flex items-start justify-between gap-3" data-id="element-61" data-mp="237l73jwpumk6">
          <div className="min-w-0" data-id="element-62" data-mp="284br2ibn62av">
            <p className="text-xs text-muted" data-id="element-63" data-mp="285d24msnqosl">{creator?.name}</p>
            <Link to={`/produit/${product.id}`} onClick={onNavigate} className={`mt-0.5 block font-medium leading-snug hover:text-clay ${large ? 'text-base' : 'text-sm'}`} data-id="element-64" data-mp="2vueayb5ek1ye">
              {product.name}
            </Link>
            {line.option && product.options && <p className="mt-1 text-xs text-muted" data-id="element-65" data-mp="2qu04uynd3230">
                {product.options.label} : {line.option}
              </p>}
            {leaving && creator && <p className="mt-1 text-xs text-clay" data-id="element-66" data-mp="1fhha3ve19l25">En vitrine jusqu’au {formatDate(creator.exhibitionEnd)}</p>}
          </div>
          <p className="shrink-0 text-sm font-medium tabular-nums" data-id="element-67" data-mp="3i563gb22ebb1">{formatPrice(product.price * line.quantity)}</p>
        </div>
        <div className="mt-auto flex items-center justify-between pt-3" data-id="element-68" data-mp="38d0b307whrvb">
          <QuantityStepper size="sm" value={line.quantity} max={product.stock} min={1} onChange={q => updateQuantity(line.key, q)} data-id="element-69" data-mp="38ax8zhth48a8" />
          <button type="button" onClick={() => removeItem(line.key)} className="text-xs text-muted underline underline-offset-4 hover:text-ink" data-id="element-70" data-mp="2za8y2vzdmo1k">
            Retirer
          </button>
        </div>
        {line.quantity >= product.stock && <p className="mt-2 text-xs text-muted" data-id="element-71" data-mp="2khp70tpi470h">
            {product.stock === 1 ? 'Pièce unique' : `Stock maximum atteint (${product.stock})`}
          </p>}
      </div>
    </div>;
}